import { render } from "./dialogAyudaRecepcionOficios.vue?vue&type=template&id=013efc84&scoped=true"
import script from "./dialogAyudaRecepcionOficios.vue?vue&type=script&lang=js"
export * from "./dialogAyudaRecepcionOficios.vue?vue&type=script&lang=js"

import "./dialogAyudaRecepcionOficios.vue?vue&type=style&index=0&id=013efc84&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013efc84"]])

export default __exports__